var path = 'api/Portal/MothersWorksheet'

function mothersWorksheetInsertComplete (http, dto) {
    return http.post(path + 'InsertComplete', dto)
}

function mothersWorksheetInsertIncomplete (http, dto) {
    return http.post(path + 'InsertIncomplete', dto)
}

function getIncompleteWorksheets (http) {
    return http.get(path + 'GetIncompleteWorksheets')
}

function getWorksheetById (http, id) {
    return http.get(path + 'GetWorksheetById?WorksheetId=' + id, { worksheetId: id })
}

export default {
    mothersWorksheetInsertComplete: mothersWorksheetInsertComplete,
    mothersWorksheetInsertIncomplete: mothersWorksheetInsertIncomplete,
    getIncompleteWorksheets: getIncompleteWorksheets,
    getWorksheetById: getWorksheetById
}
